import { MainTemplate } from "@/components/templates";
import { AuthContext, AuthStatus, SessionInfo } from "@/contexts/AuthContext";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { serviceLogin } from "@/libs/serviceLogin";
import { useServicesLazyQuery } from "@/generated/graphql";
import { Services } from "@/models";
import { useSnackBar } from "@moneyforward/mfx_biz_react_components";
import {
  Service,
  ServiceType,
  useCompanyLazyQuery,
} from "@/generated/graphql_billing";
import useRollbarUtil from "../hooks/useRollbarUtil";

type Props = {
  sessionInfo: SessionInfo;
  app: string | string[];
};

export const RedirectServiceLoginPage = ({ sessionInfo, app }: Props) => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const { authStatus } = useContext(AuthContext);
  const [services, setServices] = useState<Services>();
  const [availableServiceMap, setAvailableServiceMap] =
    useState<Map<string, Service>>();
  const { notify } = useSnackBar();
  const router = useRouter();

  const [servicesQuery] = useServicesLazyQuery({
    onCompleted: (data) => {
      if (data.services) {
        setServices(new Services(data.services));
      }
    },
    onError: getNotifyErrorHandlerForGraphQL("Failed to get services"),
  });

  const [companyQuery] = useCompanyLazyQuery({
    onCompleted: (data) => {
      if (data.company) {
        const availableServiceMap = new Map(
          data.company?.availableServices
            .filter((service) => service.type === ServiceType.Mikatano)
            .map((service) => [service.code.toLowerCase(), service])
        );
        setAvailableServiceMap(availableServiceMap);
      }
    },
    onError: getNotifyErrorHandlerForGraphQL("Failed to get company"),
    context: {
      api: "billing",
    },
  });

  useEffect(() => {
    if (authStatus === AuthStatus.SignedIn) {
      servicesQuery();
      if (app == "loan") {
        setAvailableServiceMap(new Map());
      } else {
        companyQuery();
      }
    }
  }, [authStatus]);

  // [TODO] We should refactor this code.
  // - use constants values from @/libs/queryParams.ts > QUERY_PARAM_APP
  // - e.g. app == "bfm" -> app == QUERY_PARAM_APP.bfm
  useEffect(() => {
    if (services && availableServiceMap) {
      console.log(app);
      console.log(services.loan.isEnabled());
      console.log(services.loan.redirectURL);

      if (
        app == "bfm" &&
        services.bfm.isEnabled() &&
        availableServiceMap.has(app)
      ) {
        serviceLogin(services.bfm.redirectURL, sessionInfo);
      } else if (
        app == "dxf" &&
        services.dxf.isEnabled() &&
        availableServiceMap.has(app)
      ) {
        serviceLogin(services.dxf.redirectURL, sessionInfo);
      } else if (
        app == "invoice" &&
        services.invoice.redirectURL &&
        availableServiceMap.has(app)
      ) {
        serviceLogin(services.invoice.redirectURL, sessionInfo);
      } else if (app == "loan" && services.loan.isEnabled()) {
        serviceLogin(services.loan.redirectURL, sessionInfo);
      } else {
        router.query.app = [];
        router.push("/select-service");
      }
    }
  }, [services, availableServiceMap]);

  return <MainTemplate disableAccountDropDown={true} />;
};
